import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import locationsData from '../JsonData/locations.json';
import { motion } from 'framer-motion';
const Gallery = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(null);
  const [arrowVisibility, setArrowVisibility] = useState({});
  const slideInFromBottom = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.8, ease: "easeOut" },
  };


  const handleInteraction = (id) => {
    if (window.innerWidth < 768) {
      // Mobile: treat click as hover
      openDialog(id);
    }
  };

  const openDialog = (id) => {
    if (isOpen === id) {
      closeDialog();
    } else {
      setIsOpen(id);
      setArrowVisibility(() => {
        const updatedVisibility = {};
        locationsData.forEach((location) => {
          updatedVisibility[location.id] = true;
        });
        updatedVisibility[id] = false;
        return updatedVisibility;
      });
    }
  };



  const closeDialog = () => {
    setIsOpen(null);
    setArrowVisibility((prev) => {
      const updatedVisibility = { ...prev };
      for (let key in updatedVisibility) {
        updatedVisibility[key] = true;
      }
      return updatedVisibility;
    });

  };

  return (
    <section className=" flex flex-col items-center text-center">
      < motion.div className="lg:w-[689px] lg:h-[175px] md:w-[548px] md:h-[134px] w-[362px] h-[128px] px-4"{...slideInFromBottom}>
        <div className="w-full flex justify-center">
          <div className="flex items-center">
            <h2 className="lg:text-[24px] lg:leading-[22px] md:text-[18px] md:leading-[24px] text-[14px] leading-[14px] font-lora font-medium">Gallery</h2>

            {/* SVG line next to "Gallery" */}
            <div className="ml-2">
              {/* Mobile view (default) */}
              <svg
                className="block md:hidden mt-2"
                width="32"
                height="1"
                viewBox="0 0 32 1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="0.5" x2="32" y2="0.5" stroke="black" strokeWidth="0.5" />
              </svg>

              {/* Tablet view */}
              <svg
                className="hidden md:block lg:hidden mt-4"
                width="64"
                height="1"
                viewBox="0 0 64 1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="0.5" x2="64" y2="0.5" stroke="black" strokeWidth="0.5" />
              </svg>

              {/* Desktop view */}
              <svg
                className="hidden lg:block mt-6"
                width="64"
                height="1"
                viewBox="0 0 64 1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="0.5" x2="64" y2="0.5" stroke="#000000"  strokeWidth="0.5"/>
              </svg>
               
               

            </div>
          </div>
        </div>

        <h2 className="  lg:mt-[24px] font-lora md:text-[24px] lg:text-[38px] font-medium text-[18px] md:mt-[16px] mt-[12px]  mb-4">
          Discover the Beauty of our spaces
        </h2>
        <p className="outfit-text  ">
          Explore Znorm homes through our gallery, showcasing cozy interiors, stylish designs and views.
          Each space is crafted to make your stay truly special.
        </p>
      </motion.div>
      <div className="flex  flex-items justify-center  lg:mt-[96px] mt-[40px] md:mt-[64px] ">
        <motion.div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:gap-[36px] md:gap-[24px] lg:w-[1300px] w-full px-4 mx-auto justify-items-center" {...slideInFromBottom}>
          {locationsData.map((location) => (
            <div key={location.id} className="relative flex flex-col items-center justify-center ">
              <div className="relative xl:w-[409px] xl:h-[409px] lg:w-[320px] lg:h-[320px] md:w-[340px] md:h-[340px] w-[362px] h-[362px] ">
                <div className="absolute top-0 left-0 m-4 text-[14px] md:text-[18px] lg:text-[24px] leading-[24px] font-medium text-left text-[#F0F0F0] font-lora px-2 py-1 rounded-lg">

                  {location.location}
                </div>

                <img
                  src={location.image}
                  alt={location.location}
                  className="w-full h-full object-cover rounded-[30px] "

                />

                {arrowVisibility[location.id] !== false && (
                  <button
                    className="absolute top-0 right-0 m-4 p-2 text-white rounded-full hover:bg-[#9ABB7A]"
                    onMouseEnter={() => openDialog(location.id)}
                    onClick={() => handleInteraction(location.id)}
                  >

                    <img
                      src="/images/Home/Button.webp"
                      alt="Arrow Button"
                      className="w-[32px] h-[32px] md:w-[36px] md:h-[36px] lg:w-[50px] lg:h-[50px]"
                    />
                  </button>
                )}
                {isOpen === location.id && (
                  <div className="absolute bottom-4 left-4 right-4 bg-black rounded-[20px] lg:w-auto lg:h-[auto] lg:py-6 md:w-[316px] md:h-[284px] w-[338px] h-[219px] lg:px-4">

                    <div className="bg-black text-white font-lora rounded-lg flex flex-col p-4 w-[306px] h-[120px] md:w-[268px] md:h-[180px] lg:w-full lg:h-auto">

                      {/* Top row: Location name and button */}
                      <div className="flex justify-between items-center w-full px-2">
                        <h3 className="text-[14px] md:text-[18px] lg:text-[24px] leading-tight font-medium text-left ">
                          {location.location}
                        </h3>
                        <button
                          className="p-1 text-white rounded-full shadow-lg hover:bg-[#9ABB7A] flex items-center justify-center transition-all duration-300"
                          onClick={() => {
                            if (location.id === 3) {
                              window.open("https://www.zotel.ai/website/1710", "_blank");
                            } else {
                              navigate(`/place/${location.id}`);
                            }
                          }}
                        >
                          <img
                            src="/images/Home/Button.webp"
                            alt="Arrow Button"
                            className="w-[32px] h-[32px] md:w-[36px] md:h-[36px] lg:w-[50px] lg:h-[50px]"
                          />
                        </button>
                      </div>

                      {/* Bottom description */}
                      <div className="mt-2 md:mt-4 text-left px-2 font-outfit text-[12px] md:text-[14px] lg:text-[16px] text-[#D0D0D0]">
                        <p>{location.description}</p>
                      </div>
                    </div>

                  </div>
                )}

              </div>
              {/* For mobile image spaceing */}
              <div className="   mt-6 " ></div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Gallery;
